<template>
  <div class="list-table">
    <div class="search">
      <el-select v-model="params.status" placeholder="状态筛选" @change="getUserList" clearable @clear="getUserList">
        <el-option label="未认证" value="1"></el-option>
        <el-option label="认证中" value="2"></el-option>
        <el-option label="认证通过" value="3"></el-option>
        <el-option label="认证失败" value="4"></el-option>
      </el-select>
    </div>

    <div class="table-box">
      <el-table :data="userList" style="width: 100%" :header-cell-style="{color:'#B4B4B4',height:'36px',border:'none',padding:0, background:'rgba(0,77,160,0.05)'}" :row-style="{height:'48px',padding:'0',background:'rgba(0,77,160,0.05)', borderRadius:'5px'} " :cell-style=" {fontSize:'14px',padding:0,border:'none',color:'#5C5C5C'}">
        <el-table-column label="用户名" prop="username" />
        <el-table-column label="真实姓名" prop="realName" />
        <el-table-column label="证件类型" prop="idCardType" />
        <el-table-column label="证件号码：" prop="idCard" show-overflow-tooltip />
        <el-table-column label="创建时间：" prop="createAt" show-overflow-tooltip />
        <el-table-column label="认证状态：">
          <template slot-scope="{row}">
            <span v-if="row.status==='1'">未认证</span>
            <span v-if="row.status==='2'">认证中</span>
            <span v-if="row.status==='3'">认证通过</span>
            <span v-if="row.status==='4'">认证失败</span>
          </template>
        </el-table-column>
        <el-table-column label="账号状态">
          <template slot-scope="{row}">
            <span :style="{ color: row.frozen ? '#F56C6C' : '#67C23A' }">{{ row.frozen ? '已冻结' : '正常' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="140">
          <template slot-scope="{row}">
            <el-button type="text" @click="checkUser(row)">查看</el-button>
            <el-button type="text" :style="{ color: row.frozen ? '#67C23A' : '#F56C6C' }" @click="changeFrozen(row)">{{ row.frozen ? '解冻' : '冻结' }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <el-button type="primary" :disabled="params.page_num==1" @click="handleUpPage">上一页</el-button>
      <el-button type="primary" @click="handleNextPage" :disabled="userList.length<10">下一页</el-button>
    </div>
    <user-dialog :dialog-visible="userDialog" @getUserList="getUserList" />
  </div>
</template>

<script>
import { getUserList, setUserFrozen } from '@/api/certify'
import UserDialog from './userDialog.vue'
export default {
  components: {
    UserDialog,
  },
  data() {
    return {
      params: {
        page_num: 1,
        page_size: 10,
        status: ''
      },
      userList: [],
      userDialog: {},
      userInfo: {},
    }
  },
  mounted() {
    this.getUserList()
  },
  methods: {
    async getUserList() {
      const res = await getUserList(this.params)
      this.userList = res.list
    },

    checkUser(row) {
      this.userDialog = {
        show: true,
        detailData: row
      }
    },

    async changeFrozen(row) {
      const frozen = !row.frozen
      const action = frozen ? '冻结' : '解冻'
      try {
        await this.$confirm(`确认${action}用户“${row.username}”吗？`, `${action}用户`, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: frozen ? 'warning' : 'info'
        })
      } catch (error) {
        return
      }
      await setUserFrozen({
        user_id: row.userId,
        frozen
      })
      this.$message.success(`${action}成功`)
      await this.getUserList()
    },

    handleUpPage() {
      this.params.page_num--
      this.getUserList()
    },
    handleNextPage() {
      this.params.page_num++
      this.getUserList()
    }
  }
}
</script>


